export const locales = ["en", "hi"] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

/** URL prefix for each locale. Default locale has no prefix (root). */
export const localePrefix: Record<Locale, string> = {
  en: "",
  hi: "/hi",
};

/** BCP 47 language tag for the HTML lang attribute. */
export const localeLang: Record<Locale, string> = {
  en: "en",
  hi: "hi",
};

/** Display name shown in the language toggle UI. */
export const localeLabel: Record<Locale, string> = {
  en: "EN",
  hi: "हिंदी",
};

/**
 * Slugs whose translated page intentionally uses a different URL slug.
 * Keeps language toggle and hreflang alternates from linking to 404s.
 */
export const localeSlugAliases: Partial<Record<Locale, Record<string, string>>> = {
  en: {
    "aaj-ka-rashifal": "rashifal",
    // /remedies/ 301-redirects to /upay/; hreflang must point to the final URL
    remedies: "upay",
  },
  hi: {
    rashifal: "aaj-ka-rashifal",
    remedies: "upay",
  },
};

/**
 * Slugs that have a Hindi equivalent page at /hi/{slug}.
 * Used by LanguageToggle to decide where to link.
 */
export const HINDI_SLUGS = new Set([
  "panchang",
  "rashifal",
  "nakshatra",
  "rashi",
  "free-kundali",
  "kundli-matching",
  "choghadiya",
  "rahu-kaal",
  "muhurat",
  "numerology",
  "name-numerology",
  "mulank-calculator",
  "bhagyank-calculator",
  "baby-names",
  "ascendant-calculator",
  "nakshatra-calculator",
  "rashi-calculator",
  "mangal-dosha-calculator",
  "nadi-astrology",
  "dasha-calculator",
  "gun-milan",
  "sade-sati",
  "transits",
  "remedies",
  "upay",
  "compatibility",
  "astrologers",
  "pandits",
  "kaal-sarp-dosha",
  "pitra-dosha",
  "graha",
  "aaj-ka-rashifal",
  "bhai-dooj-2026",
  "chhath-puja-2026",
  "dhanteras-2026",
  "diwali-2026",
  "dussehra-2026",
  "ganesh-chaturthi-2026",
  "karwa-chauth-2026",
  "navratri-2026",
  "raksha-bandhan-2026",
  "holi-2027",
  "janmashtami-2026",
  "govardhan-puja-2026",
  "mantras",
  // Vrat hubs with Hindi twins at /hi/<slug>/ (highest-CVR surfaces, rule 46).
  "ekadashi",
  "amavasya",
  "purnima",
  "pradosh",
  "sankashti-chaturthi",
  "masik-shivratri",
  "sankranti",
  "vrat-calendar",
]);
